import { authDomain } from '../../Common/constants';

export const authenticationUrl = `${authDomain}/authenticate/`;
